import React from "react";
import Footer from "../components/footer";

const TermsPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-gray-200 px-6 py-12">
        <div className="max-w-5xl mx-auto">
            <h1 className="text-3xl font-bold mb-6 text-green-400">Terms & Conditions</h1>
            <p className="mb-4">By accessing and using this website, you agree to comply with and be bound by the following terms and conditions. If you disagree with any part of these terms, please do not use our website.</p>
            <h2 className="text-xl font-semibold text-white mt-6 mb-2">Use of Site</h2>
            <p className="mb-4">All content on this site is for informational purposes only and may be subject to change without notice.</p>
            <h2 className="text-xl font-semibold text-white mt-6 mb-2">User Conduct</h2>
            <p className="mb-4">You agree not to misuse the website or services offered. Any fraudulent, abusive, or otherwise illegal activity may be grounds for termination of your access.</p>
            <h2 className="text-xl font-semibold text-white mt-6 mb-2">Intellectual Property</h2>
            <p className="mb-4">All content, logos, and trademarks are the property of Pentomino Solutions unless otherwise stated.</p>
            <p className="mt-8 text-sm text-gray-400">Last updated: June 16, 2025</p>
        </div>
    </div>
);

export default TermsPage;